// src/pages/Success.js
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const Success = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate("/dashboard", { replace: true });
    }, 2500);
    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        background: "linear-gradient(135deg, #f0f9ff 0%, #e6f7ff 100%)",
        fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
        padding: "0 20px",
        textAlign: "center",
        color: "#1e3a8a",
      }}
    >
      {/* Success Badge */}
      <div
        style={{
          width: "100px",
          height: "100px",
          borderRadius: "50%",
          background: "linear-gradient(135deg, #10b981 0%, #059669 100%)",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginBottom: "24px",
          boxShadow: "0 4px 20px rgba(16, 185, 129, 0.4)",
        }}
      >
        <span style={{ fontSize: "48px", color: "white" }}>✓</span>
      </div>

      {/* Main Message */}
      <h2 style={{ fontSize: "2.2rem", fontWeight: "700", margin: "0 0 12px" }}>
        Payment Successful! 🎉
      </h2>

      <p style={{ fontSize: "1.1rem", color: "#374151", maxWidth: "500px", lineHeight: 1.5 }}>
        Your subscription is now active.
      </p>

      {/* MotherBird Value Props */}
      <div style={{ marginTop: "24px", textAlign: "left", maxWidth: "400px" }}>
        <p style={{ display: "flex", alignItems: "center", marginBottom: "10px", fontSize: "1rem" }}>
          <span style={{ color: "#10b981", marginRight: "8px" }}>✔</span>
          View loads on an interactive map
        </p>
        <p style={{ display: "flex", alignItems: "center", marginBottom: "10px", fontSize: "1rem" }}>
          <span style={{ color: "#10b981", marginRight: "8px" }}>✔</span>
          Contact brokers via email instantly
        </p>
        <p style={{ display: "flex", alignItems: "center", marginBottom: "10px", fontSize: "1rem" }}>
          <span style={{ color: "#10b981", marginRight: "8px" }}>✔</span>
          Save time and win more bids!
        </p>
      </div>

      {/* Redirect Notice */}
      <p style={{ marginTop: "28px", fontSize: "0.95rem", color: "#6b7280" }}>
        Redirecting to your dashboard...
      </p>
    </div>
  );
};

export default Success;